import { render, staticRenderFns } from "./MYP401P01.vue?vue&type=template&id=582ef84b&"
import script from "./MYP401P01.vue?vue&type=script&lang=js&"
export * from "./MYP401P01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports